import OnsiteAverageDailyRateComponent from '../generic/OnsiteDailyAverageRate/OnsiteAverageDailyRate';
import { isOnsite } from '../products/utils';
import { connectEditor } from './connect-editor';
import { getAverageDailyRate } from './utils';

const mapStateToProps = ({ campaignLinesById }) => {
  const onsiteCampaignLines = Object.values(campaignLinesById).filter(line =>
    isOnsite(line.product),
  );

  return { average: getAverageDailyRate(onsiteCampaignLines) };
};

const OnsiteAverageDailyRate = connectEditor(mapStateToProps)(
  OnsiteAverageDailyRateComponent,
);

export default OnsiteAverageDailyRate;
